import * as types from 'constants/ActionTypes'
import {
  loadProfile, updateProfile, uploadPhoto,
  loadAgentProfile, updateAgentProfile, uploadAgentPhoto
} from 'actions/profile'
import { createReducer } from 'redux-act'

const onProfileRequest = (state, payload) => (
  { ...state, isLoaded: false, isLoading: true, isFirstTimeLoaded: true }
)

export function createProfileReducer(actions) {
  const defaultState = { isLoaded: false, isFirstTimeLoaded: false }
  return createReducer(
    {
      [actions.load.request]: onProfileRequest,
      [actions.load.ok]: (state, payload) => (
        { ...state, ...payload.response, isLoaded: true, isLoading: false, isFirstTimeLoaded: true }
      ),
      ...(actions.update && {
        [actions.update.ok]: (state, payload) => (
          { ...state, ...payload.response, isLoaded: true, isLoading: false, isFirstTimeLoaded: true }
        )
      }),
      ...(actions.photo && {
        [actions.photo.ok]: (state, payload) => (
          { ...state, avatarId: payload.response.imageId }
        )
      }),
      [types.USER_LOGOUT_START]: () => defaultState
    }, defaultState
  )
}

export const agentProfile = createProfileReducer({
  load: loadAgentProfile,
  update: updateAgentProfile,
  photo: uploadAgentPhoto,
})

const reducer = createProfileReducer({
  load: loadProfile,
  update: updateProfile,
  photo: uploadPhoto,
})

reducer.on(
  'SMS_FORM_SENDING_START',
  onProfileRequest
)

reducer.on(
  'USER_LOGIN',
  (state, payload) => (
    { ...state, ...payload, isLoaded: true }
  )
)

reducer.on(
  'UPLOAD_LOGO_OK',
  (state, payload) => ({
    ...state,
    avatarId: payload.response.imageId,
  }),
);

export const profile = reducer



// WEBPACK FOOTER //
// ./src/reducers/profile.js